import React from 'react';
import Slider from "react-slick";

const Press = (props) => {
  const colorString = Object.values(props.theme).toString();
    var settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 8,
        slidesToScroll: 1,
        autoplay: true,
        nav:false,
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 5,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 991,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true
              }
            }

          ]
    };
    return (
        <section className={colorString === 'true'?`press customSec dark`: `press customSec dark`}>
            <div className="container">
                <div className="sectionHeading justify-content-center text-center">
                    <div className="d-block">
                        <h2>PRESS RELEASE</h2>
                        <h3>Colexion is making headlines around the world.</h3>
                    </div>
                </div>
                <div className="scroller">
                    <Slider {...settings}>

                        <a href="https://www.aninews.in/news/business/business/launch-of-indias-largest-licenced-nft-platform-colexion20210912145327/" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/ani.png'} alt="" /></a>

                        <a href="https://www.apnlive.com/colexion-set-to-skyrocket-its-nft-marketplace-industry-for-sports-entertainment/" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/apn.png'} alt="" /></a>

                        <a href="https://www.business-standard.com/content/press-releases-ani/launch-of-india-s-largest-licenced-nft-platform-colexion-121091200463_1.html" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/BS.png'} alt="" /></a>

                        <a href="https://www.dnaindia.com/business/report-dubai-based-serial-entrepreneur-abhay-agarwal-has-big-goals-for-the-nft-and-crypto-platforms-2912002" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/dna.png'} alt="" /></a>

                        <a href="https://www.kuwaittimes.news/news/launch-of-indias-largest-licenced-nft-platform-colexion20210912145324/
" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/Kuwait_times.png'} alt="" /></a>

                        <a href="https://www.outlookindia.com/website/story/outlook-spotlight-asias-first-officially-licensed-digital-collectibles-platform-colexion-to-drop-unique-nfts/395369" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/outlook.png'} alt="" /></a>

                        <a href="https://www.thehindu.com/brandhub/pr-release/launch-of-largest-licenced-nft-platform-colexion/article36426135.ece" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/thehindu.png'} alt="" /></a>

                        <a href="https://theprint.in/theprint-valuead-initiative/nfts-to-enter-the-mainstream-in-india-with-the-launch-of-colexion/731528/" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/the-print.png'} alt="" /></a>


                        <a href="https://www.aninews.in/news/business/business/launch-of-indias-largest-licenced-nft-platform-colexion20210912145327/" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/ani.png'} alt="" /></a>

                        <a href="https://www.apnlive.com/colexion-set-to-skyrocket-its-nft-marketplace-industry-for-sports-entertainment/" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/apn.png'} alt="" /></a>

                        <a href="https://www.business-standard.com/content/press-releases-ani/launch-of-india-s-largest-licenced-nft-platform-colexion-121091200463_1.html" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/BS.png'} alt="" /></a>

                        <a href="https://www.dnaindia.com/business/report-dubai-based-serial-entrepreneur-abhay-agarwal-has-big-goals-for-the-nft-and-crypto-platforms-2912002" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/dna.png'} alt="" /></a>

                        <a href="https://www.kuwaittimes.news/news/launch-of-indias-largest-licenced-nft-platform-colexion20210912145324/
" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/Kuwait_times.png'} alt="" /></a>

                        <a href="https://www.outlookindia.com/website/story/outlook-spotlight-asias-first-officially-licensed-digital-collectibles-platform-colexion-to-drop-unique-nfts/395369" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/outlook.png'} alt="" /></a>

                        <a href="https://www.thehindu.com/brandhub/pr-release/launch-of-largest-licenced-nft-platform-colexion/article36426135.ece" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/thehindu.png'} alt="" /></a>

                        <a href="https://theprint.in/theprint-valuead-initiative/nfts-to-enter-the-mainstream-in-india-with-the-launch-of-colexion/731528/" target="_blank" rel="noreferrer"><img src={process.env.PUBLIC_URL + '/images/press release/the-print.png'} alt="" /></a>
                        
                        
                    </Slider>
                </div>
            </div>
        </section>
    )
}
export default Press;